<template>
    <v-container fluid>
        <confirm-dialog title="Unsaved changes" button-caption="Leave" v-model="leaveDialog" @confirm="confirmLeave(true)" @cancel="confirmLeave(false)">
          There are unsaved changes in the box definition. The changes will be lost if you leave now. Are you sure?
        </confirm-dialog>
        <p>The <strong>Home</strong> box is used on all pages except <strong>Cart</strong> and <strong>Product</strong>. It lists all the recommended products.</p>
        <web-box-configurator box="home" :dirty.sync="dirty" />
    </v-container>
</template>
<script>
  import WebBoxConfigurator from '@/components/WebBoxConfigurator'
  import ConfirmLeave from '@/mixins/confirm-leave'

  export default {
    name: 'WebBoxHome',
    mixins: [ConfirmLeave],
    components: { WebBoxConfigurator },
  }
</script>